//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function extend(to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
}

var alert = {
  type: 'alert',
  // alert 只有确定按钮 confirm 确定和取消按钮
  show: false,
  msg: '温馨提示',
  confirm: null,
  cancel: null,
  confirmText: '确定',
  cancelText: '取消',
  title: '',
  align: ''
};
export default {
  data: function data() {
    return alert;
  },
  methods: {
    confirmClick: function confirmClick() {
      alert.show = false;
      alert.confirm && alert.confirm();
    },
    cancelClick: function cancelClick() {
      alert.show = false;
      alert.cancel && alert.cancel();
    }
  },
  install: function install(Vue) {
    /**
     * alert
     * @param options 提示内容或者配置对象
     */
    var alertFunc = Vue.prototype.alert = function (options) {
      if (typeof options === 'string') {
        options = {
          msg: options
        };
      }

      var _options = options,
          _options$title = _options.title,
          title = _options$title === void 0 ? '' : _options$title,
          _options$msg = _options.msg,
          msg = _options$msg === void 0 ? '' : _options$msg,
          _options$confirm = _options.confirm,
          confirm = _options$confirm === void 0 ? null : _options$confirm,
          _options$confirmText = _options.confirmText,
          confirmText = _options$confirmText === void 0 ? '确定' : _options$confirmText,
          _options$align = _options.align,
          align = _options$align === void 0 ? '' : _options$align;
      extend(alert, {
        title: title,
        msg: msg,
        confirm: confirm,
        confirmText: confirmText,
        type: 'alert',
        show: true,
        align: align
      });
    };
    /**
     * confirm
     * @param title
     * @param msg
     * @param confirm
     * @param cancel
     * @param v_btnConfirmText
     * @param v_btnCancelText
     */


    var confirmFunc = Vue.prototype.confirm = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options,
          _ref$title = _ref.title,
          title = _ref$title === void 0 ? '' : _ref$title,
          _ref$msg = _ref.msg,
          msg = _ref$msg === void 0 ? 'confirm需要至少传入msg' : _ref$msg,
          _ref$confirm = _ref.confirm,
          confirm = _ref$confirm === void 0 ? null : _ref$confirm,
          _ref$cancel = _ref.cancel,
          cancel = _ref$cancel === void 0 ? null : _ref$cancel,
          _ref$confirmText = _ref.confirmText,
          confirmText = _ref$confirmText === void 0 ? '确定' : _ref$confirmText,
          _ref$cancelText = _ref.cancelText,
          cancelText = _ref$cancelText === void 0 ? '取消' : _ref$cancelText,
          _ref$align = _ref.align,
          align = _ref$align === void 0 ? '' : _ref$align;

      extend(alert, {
        title: title,
        msg: msg,
        confirm: confirm,
        cancel: cancel,
        confirmText: confirmText,
        cancelText: cancelText,
        type: 'confirm',
        show: true,
        align: align
      });
    };

    return {
      alert: alertFunc,
      confirm: confirmFunc
    };
  }
};